import React, { forwardRef, useEffect } from "react";
import PropTypes from "prop-types";
import { MIME_EXTENSIONS } from "~/constants/mime-types";

const audioStyles = { width: "100%" };

const NativeAudio = ({
  forwardedRef,
  sourcePath,
  mimeType = MIME_EXTENSIONS["mp3"]
}) => {
  useEffect(() => {
    forwardedRef.current.pause();
    forwardedRef.current.load();
  }, [forwardedRef, sourcePath]);

  return (
    <audio
      ref={forwardedRef}
      controls
      controlsList="nodownload"
      style={audioStyles}
    >
      <source src={sourcePath} type={mimeType} />
      Dieser Browser untersützt die Wiedergabe von Mp3-Dateien nicht
    </audio>
  );
};

NativeAudio.propTypes = {
  forwardedRef: PropTypes.object,
  sourcePath: PropTypes.string,
  mimeType: PropTypes.string
};

const Audio = forwardRef((props, ref) => (
  <NativeAudio {...props} forwardedRef={ref} />
));

Audio.displayName = "Audio";

export default Audio;

// class NativeAudio extends Component {
//   shouldComponentUpdate(prevProps) {
//     return prevProps.sourcePath !== this.props.sourcePath;
//   }

//   render() {
//     const {
//       forwardedRef,
//       sourcePath,
//       mimeType = MIME_EXTENSIONS["mp3"]
//     } = this.props;

//     return (
//       <audio
//         ref={forwardedRef}
//         controls
//         controlsList="nodownload"
//         style={audioStyles}
//       >
//         <source src={sourcePath} type={mimeType} />
//         Dieser Browser untersützt die Wiedergabe von Mp3-Dateien nicht
//       </audio>
//     );
//   }
// }
